import {Component,
        Input,
        Output,
        EventEmitter,
        transition,
        state,
        style,
        animate,
        trigger} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {OpenAPIService} from '../services/openapi';
import {UtilsService} from '../services/utils';
import {MenuService, MenuItem} from '../services/menu';
import {SearchService} from '../services/search';
import {RoutesService} from '../services/routes';
import { PlatformService } from '../services/platform.service';

declare let window:any;

const matchOrChildMatch = (cond, item) => {
  if (Array.isArray(item)) return !!item.filter(i => matchOrChildMatch(cond, i)).length;
  if (cond(item)) return true;
  if (item.children) return matchOrChildMatch(cond, item.children);
  return false;
}

@Component({
    selector: 'side-menu',
    templateUrl: '../views/side-menu.pug',
})
export class SideMenuComponent {
  @Input() basePage;
  hideMenu:boolean;
  exactMatch:any = null;

  subscriptions:any[] = [];

  constructor(private route:ActivatedRoute,
              private routes:RoutesService,
              public platformService: PlatformService,
              public utils:UtilsService,
              public openapi:OpenAPIService,
              public menu:MenuService,
              public search:SearchService) {
    window.sideMenuComponent = this;
    const BOOTSTRAP_XS_MAX = 768;
    if (window.innerWidth < BOOTSTRAP_XS_MAX) {
      this.hideMenu = true;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit() {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.search.query = params['query'];
    }));
    if (this.basePage === 'console') {
      let lastQuery = undefined;
      this.subscriptions.push(this.search.results.subscribe(results => {
        if (!this.search.query) return this.exactMatch = lastQuery = null;
        let lower = this.search.query.toLowerCase();
        this.exactMatch = this.menu.getItemWithCond(i => i.title.toLowerCase() === lower);
        if (this.exactMatch && this.exactMatch.operation && lastQuery !== undefined && this.search.query !== lastQuery) {
          this.menu.setActiveItem(this.exactMatch);
        }
        lastQuery = this.search.query;
      }));
    }
  }
}

@Component({
    selector: 'side-menu-item',
    templateUrl: '../views/side-menu-item.pug',
    animations: [
      trigger('shrinkOut', [
        state('in', style({height: '*'})),
        transition('* => void', [
          style({height: '*', overflow: 'hidden'}),
          animate(250, style({height: 0}))
        ]),
        transition('void => *', [
          style({height: 0, overflow: 'hidden'}),
          animate(250, style({height: '*'}))
        ])
      ]),
    ],
})
export class SideMenuItemComponent {
  @Input() item;
  @Input() basePage;
  @Input() query;
  title:string;
  animateReady:boolean;

  constructor(public utils:UtilsService,
              public search:SearchService,
              public routes:RoutesService) {}

  ngAfterViewInit() {
    this.animateReady = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/side-menu.ts